// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"faq_scrollbar__2Rj4o"};